import type { RecordUser } from '@domain/schemas/database.schema';
import type { AuditEntry } from '@domain/types/audit-log';

import { USER_DISPLAY_NAME_MAP } from '../constants';

const hasUserAttached = (user: RecordUser | undefined): user is RecordUser => {
  return user !== undefined;
};

export const mapAuditItemUser = (item: AuditEntry): AuditEntry => {
  if (!hasUserAttached(item.user)) {
    return item;
  }

  const displayName = USER_DISPLAY_NAME_MAP[item.user.name];

  if (!displayName) {
    return item;
  }

  // Display-only rename. It applies to system-role rows too: they can carry stored names like 'Bot Bot', which
  // SystemUser's literal name doesn't describe, hence the assertion back to the entry's user type.
  return {
    ...item,
    user: { ...item.user, name: displayName } as RecordUser,
  };
};
